import "./appTitleBar.scss";

import PropTypes from "prop-types";
import React from "react";

import ColorDot from "../interface/ColorDot";

const AppTitleBarTitleView = props => (
  <div className="appTitleBarTitle">
    <span>{props.title}</span>
    {props.isDirty ? <ColorDot color="white" /> : null}
  </div>
);

AppTitleBarTitleView.propTypes = {
  title: PropTypes.string,
  isDirty: PropTypes.bool
};

export default AppTitleBarTitleView;
